import VState from '../v-state'

const colors = [
  '#ffaf36', // orange,
  '#C0D725', // lime,
  '#FFA266', // peach,
  '#00A28A', // teal
  '#3fe092' // sea green
]

const primaryColorState = new VState('#ffaf36')

const setPrimaryColor = color => primaryColorState.set(color)
const usePrimaryColor = (...args) => primaryColorState.use(...args)
const inheritPrimaryColor = props => props.theme.primaryColor

export {
  colors,
  usePrimaryColor,
  setPrimaryColor,
  inheritPrimaryColor
}